export default "__VITE_ASSET__C3T5uS2L__"